"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
var Symbol = require("es6-symbol");
var _1 = require("./");
var TYPES = {
    CompanyBatchClient: Symbol("CompanyBatchClient"),
    CompanyBatchRoute: Symbol("CompanyBatchRoute"),
    CompanyClient: Symbol("CompanyClient"),
    CompanyRoute: Symbol("CompanyRoute"),
    OrganizationBatchClient: Symbol("OrganizationBatchClient"),
    OrganizationBatchRoute: Symbol("OrganizationBatchRoute"),
    OrganizationClient: Symbol("OrganizationClient"),
    OrganizationRoute: Symbol("OrganizationRoute"),
    SkillBatchClient: Symbol("SkillBatchClient"),
    SkillBatchRoute: Symbol("SkillBatchRoute"),
    SkillClient: Symbol("SkillClient"),
    SkillRoute: Symbol("SkillRoute"),
    UserEducationClient: Symbol("UserEducationClient"),
    UserEducationRoute: Symbol("UserEducationRoute"),
    UserProfileACLClient: Symbol("UserProfileACLClient"),
    UserProfileACLRoute: Symbol("UserProfileACLRoute"),
    UserProfileAvatarClient: Symbol("UserProfileAvatarClient"),
    UserProfileAvatarRoute: Symbol("UserProfileAvatarRoute"),
    UserProfileAvatarStreamsClient: Symbol("UserProfileAvatarStreamsClient"),
    UserProfileAvatarStreamsRoute: Symbol("UserProfileAvatarStreamsClient"),
    UserProfileClient: Symbol("UserProfileClient"),
    UserProfileRoute: Symbol("UserProfileRoute"),
    UserSkillClient: Symbol("UserSkillClient"),
    UserSkillRoute: Symbol("UserSkillRoute"),
    UserWorkClient: Symbol("UserWorkClient"),
    UserWorkRoute: Symbol("UserWorkRoute"),
    Root: Symbol("UserProfile-Root")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.CompanyBatchRoute).to(_1.CompanyBatchRoute);
    bind(TYPES.CompanyBatchClient).to(_1.CompanyBatchClient);
    bind(TYPES.CompanyRoute).to(_1.CompanyRoute);
    bind(TYPES.CompanyClient).to(_1.CompanyClient);
    bind(TYPES.OrganizationBatchRoute).to(_1.OrganizationBatchRoute);
    bind(TYPES.OrganizationBatchClient).to(_1.OrganizationBatchClient);
    bind(TYPES.OrganizationRoute).to(_1.OrganizationRoute);
    bind(TYPES.OrganizationClient).to(_1.OrganizationClient);
    bind(TYPES.SkillBatchRoute).to(_1.SkillBatchRoute);
    bind(TYPES.SkillBatchClient).to(_1.SkillBatchClient);
    bind(TYPES.SkillRoute).to(_1.SkillRoute);
    bind(TYPES.SkillClient).to(_1.SkillClient);
    bind(TYPES.UserEducationRoute).to(_1.UserEducationRoute);
    bind(TYPES.UserEducationClient).to(_1.UserEducationClient);
    bind(TYPES.UserProfileACLRoute).to(_1.UserProfileACLRoute);
    bind(TYPES.UserProfileACLClient).to(_1.UserProfileACLClient);
    bind(TYPES.UserProfileAvatarStreamsRoute).to(_1.UserProfileAvatarStreamsRoute);
    bind(TYPES.UserProfileAvatarStreamsClient).to(_1.UserProfileAvatarStreamsClient);
    bind(TYPES.UserProfileAvatarRoute).to(_1.UserProfileAvatarRoute);
    bind(TYPES.UserProfileAvatarClient).to(_1.UserProfileAvatarClient);
    bind(TYPES.UserProfileRoute).to(_1.UserProfileRoute);
    bind(TYPES.UserProfileClient).to(_1.UserProfileClient);
    bind(TYPES.UserSkillRoute).to(_1.UserSkillRoute);
    bind(TYPES.UserSkillClient).to(_1.UserSkillClient);
    bind(TYPES.UserWorkRoute).to(_1.UserWorkRoute);
    bind(TYPES.UserWorkClient).to(_1.UserWorkClient);
    bind(TYPES.Root).to(_1.Root);
});
exports.diModule = diModule;
